import React, { useEffect, useRef, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'
import API_ENDPOINTS from '../../../helperFunction/Constant';
import ApiHelper from '../../../helperFunction/ApiHelper';
import Layout from '../../common/Layout';

const Enrolled = () => {

    const toast = useRef(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [enrolledData, setEnrolledData] = useState([])
    const navigate = useNavigate()

    const { quizId } = useParams()

    useEffect(() => {
        getQuizData()
    }, [])

    const getQuizData = () => {
        ApiHelper.get(`${API_ENDPOINTS.QUIZ_ENROLLED_USERS}/${quizId}`).then((res) => {
            if (res.status === 200) {
                setEnrolledData(res?.data?.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const imageBodyTemplate = (rowData) => {
        return (
            rowData?.userName ? (
                <div style={{ display: "flex", alignItems: "center", gap: "10px", color:'blue', cursor:'pointer' }} onClick={() => navigate(`/quiz/${quizId}/enrolled-users/${rowData.userId}`)} >
                    {rowData?.userName}
                    <br/>
                    {rowData?.userMobileNumber}
                </div>
            ) : (
                <i className="pi pi-image"></i>
            )
        );
    };

    const attemptBodyTemplate = (rowData) => {
        return (
            <>
                <div className='d-flex gap-1 align-items-center'>
                    <span className='badge text-bg-light m-0' style={{cursor: 'pointer', fontSize: '15px'}} onClick={() => navigate(`/quiz/${quizId}/enrolled-users/${rowData.userId}`)} >{rowData?.userAttempts}</span>
                </div>
            </>
        );
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

  return (
    <>
        <Toast ref={toast} />
        <ConfirmDialog />
        <Layout>
            <div class="content-wrapper">
                <div class="container-xxl flex-grow-1 container-p-y">
                    <div class="d-flex justify-content-between align-items-center py-3">
                        <h4 class="fw-bold py-3 mb-2">
                            <span class="d-flex text-muted fw-light"> 
                                <p class="breadcrumb-item pageHeader active me-2 mb-0" aria-current="page" onClick={() => navigate('/quiz')}> Quiz </p> / <b className='mx-2'> Enrolled Users </b>
                            </span>
                        </h4>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card mb-4">
                                <div class="card-body">
                                    <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={enrolledData} tableStyle={{ minWidth: '50rem' }} >
                                        <Column body={serialNoTemplate} header='S.NO' />
                                        <Column sortable header='Name' body={imageBodyTemplate} field='userName' /> 
                                        <Column sortable header='Email' field='userEmail' />
                                        <Column sortable header='User Attempts' body={attemptBodyTemplate} />
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    </>
  )
}

export default Enrolled
